import './Layout.css';
export default {
    "wrapper": "Layout_wrapper__qpk0z",
    "headWrapper": "Layout_headWrapper__qpk0z",
    "title": "Layout_title__qpk0z",
    "viewAll": "Layout_viewAll__qpk0z",
    "itemList": "Layout_itemList__qpk0z",
    "rightArrow": "Layout_rightArrow__qpk0z",
    "leftArrow": "Layout_leftArrow__qpk0z"
};
